// ABOUTME: Simple hint tooltip component for displaying help text
// ABOUTME: Wraps CTooltip + SimpleHintTooltip + HintIcon with proper spacing

import { memo } from "react"
import CTooltip from "./CTooltip"
import { SimpleHintTooltip } from "./tooltip/ProfileHintTooltip"
import { HintIcon } from "@shared/icons"
import useDevice from "@shared/hooks/useDevice"

interface CSimpleHintProps {
  /** Tooltip description text (supports HTML) */
  description: string
  /** Tooltip placement */
  placement?: "left" | "right" | "top" | "bottom"
  /** Override placement for mobile */
  mobilePlacement?: "left" | "right" | "top" | "bottom"
  /** Additional class name for wrapper */
  className?: string
  /** Whether description contains HTML */
  isHtml?: boolean
  /** Max width of tooltip */
  maxWidth?: string
}

const CSimpleHintComponent = ({
  description,
  placement,
  mobilePlacement,
  className = "",
  isHtml = true,
  maxWidth,
}: CSimpleHintProps) => {
  const { isMobile } = useDevice()

  const effectivePlacement = isMobile ? (mobilePlacement ?? placement ?? "top") : (placement ?? "right")

  return (
    <span className={`ml-1 cursor-pointer inline-flex items-center ${className}`}>
      <CTooltip
        placement={effectivePlacement}
        content={
          <SimpleHintTooltip
            description={description}
            isHtml={isHtml}
            maxWidth={maxWidth}
          />
        }
      >
        <HintIcon />
      </CTooltip>
    </span>
  )
}

export const CSimpleHint = memo(CSimpleHintComponent)
CSimpleHint.displayName = "CSimpleHint"
